import type { CSSProperties } from "react"
import type { BaseTextContentProps } from "./types"
import { colors } from "../../../../services/config/colors"

interface HtmlContainerProps extends BaseTextContentProps {
  html: string
  textColor?: string
  boxColor?: string
  containerStyle?: CSSProperties
  textStyle?: CSSProperties
}

export const HtmlContainer = ({
  html,
  fontSize,
  fontWeight,
  textColor,
  boxColor,
  containerStyle,
  textStyle,
}: HtmlContainerProps) => {
  return (
    <div
      style={{
        width: "100%",
        fontSize,
        fontWeight,
        lineHeight: 1.5,
        textAlign: "left",
        color: textColor ?? colors.text,
        paddingInline: 24,
        position: "relative",
        ...containerStyle,
      }}
    >
      <div
        // biome-ignore lint/security/noDangerouslySetInnerHtml: story content is trusted and controlled
        dangerouslySetInnerHTML={{ __html: html }}
        style={{
          backgroundColor: boxColor,
          borderRadius: 16,
          padding: boxColor ? 16 : 0,
          paddingRight: boxColor ? 16 : 0,
          ...textStyle,
        }}
      />
    </div>
  )
}
